import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../atoms/buttons/enums.js';
import { setDataAttributes, isRTL } from '../../utilities/dom-helpers/index.js';
import { setLineClamp } from '../../../generated/global-content/components/utilities/text-helpers/index.js';
import css_248z from './cross-sell.scss.js';

class CrossSell extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.centered = false;
        this.sixColumn = false;
        this.showOverlay = 'none';
        this.animation = true;
        this.titleSize = 'Small';
        this.headingSlot = null;
        this.textSlot = null;
        this.isDesktop = false;
        this.bodyCopy = null;
        this.ctaButton = null;
    }
    isSlotElementEmpty(name) {
        const slotElement = this.shadowRoot.querySelector(`[name="${name}"]`);
        return slotElement.assignedNodes()[0].childNodes.length === 0;
    }
    getElement(attribute) {
        return this.shadowRoot.querySelector(attribute);
    }
    fillCTAButton() {
        var _a;
        (_a = this.ctaButton) === null || _a === void 0 ? void 0 : _a.querySelector('a').classList.add('hovered');
    }
    resetCTAButton() {
        var _a;
        (_a = this.ctaButton) === null || _a === void 0 ? void 0 : _a.querySelector('a').classList.remove('hovered');
    }
    applyClassToHeadline() {
        const headlineSlot = this.shadowRoot.querySelector('slot[name="headline"]');
        if (headlineSlot) {
            const assignedElements = headlineSlot
                .assignedNodes({ flatten: true })
                .filter(node => node.nodeType === Node.ELEMENT_NODE);
            assignedElements.forEach(element => {
                if (element.tagName.toLowerCase() === 'p') {
                    element.classList.remove(...element.classList);
                    element.classList.add(this.titleSize.toLowerCase());
                }
            });
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('titleSize')) {
            this.applyClassToHeadline();
        }
    }
    firstUpdated() {
        setDataAttributes(this, 'headline', 'body-copy');
        setLineClamp(this, 55, 90);
        if (!this.isSlotElementEmpty('cta')) {
            const ctaSlot = this.getElement('[name="cta"]');
            this.ctaButton = ctaSlot.assignedNodes()[0];
        }
    }
    handleMediaQuery(e) {
        this.isDesktop = !e.detail.value;
        if (!this.isDesktop && window.innerWidth > 767) {
            this.fillCTAButton();
        }
    }
    render() {
        const isRtl = this.rtl || isRTL();
        const rtlClass = isRtl ? 'rtl' : '';
        const centeredClass = this.centered ? 'centered' : '';
        const sixColumnClass = this.sixColumn ? 'six-column' : '';
        const animationClass = this.animation ? 'hover-enabled' : 'hover-disabled';
        const overlayClassMap = {
            Gradient: 'gradient-overlay',
            'Gradient with Hugs': 'gradient-hugs-overlay',
            None: 'gradient-none',
        };
        const overlayClass = overlayClassMap[this.showOverlay] || '';
        const titleSizeClass = this.titleSize.toLowerCase();
        return x `<article class="${rtlClass} ${centeredClass} ${sixColumnClass} ${animationClass}"><div class="text-container"><slot name="headline" class="${titleSizeClass}"></slot><slot name="body-copy"></slot><slot name="cta"></slot></div><div class="img-container ${overlayClass}"><slot name="img"></slot><div class="overlay"></div></div><div class="background"></div></article><lit-media-query query="(max-width: 1365px)" @changed="${this.handleMediaQuery}"></lit-media-query>`;
    }
}
CrossSell.styles = css_248z;
__decorate([
    n({ type: Boolean })
], CrossSell.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], CrossSell.prototype, "centered", void 0);
__decorate([
    n({ type: Boolean })
], CrossSell.prototype, "sixColumn", void 0);
__decorate([
    n({ type: String })
], CrossSell.prototype, "showOverlay", void 0);
__decorate([
    n({ type: Boolean })
], CrossSell.prototype, "animation", void 0);
__decorate([
    n({ type: String })
], CrossSell.prototype, "titleSize", void 0);
__decorate([
    t()
], CrossSell.prototype, "headingSlot", void 0);
__decorate([
    t()
], CrossSell.prototype, "textSlot", void 0);
__decorate([
    t()
], CrossSell.prototype, "isDesktop", void 0);
customElements.define('cross-sell', CrossSell);

export { CrossSell };
